// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__1cc03","back-btn":"style_back-btn__1Wn6t"};